import React from 'react';
import { Button, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useChatbotSettingsContext } from '../../../utils/ContextProviders/ChatbotSettingsContextProvider';
import { useDispatch } from 'react-redux';
import { setSuccessInfo } from '../../../Redux/Reducer/GlobalError';

const ChatbotScript = () => {
  const { view } = useChatbotSettingsContext();
  const dispatch = useDispatch();
  const apartmentId = view.communityId;

  const script = `
  <script src="https://apis-v2.residentboost.com/chatbot/script?apartmentId=${apartmentId}"></script>`;

  const handleCopy = () => {
    navigator.clipboard.writeText(script).then(() => {});
    dispatch(setSuccessInfo('Copied!'));
  };

  return (
    <div
      style={{
        padding: '16px',
        marginRight: '16px',
        border: '1px solid var(--rb-divider, #e0e0e0)',
        borderRadius: '8px'
      }}
    >
      <Typography
        fontWeight="bold"
        sx={{ display: 'block', mb: 2, fontSize: '16px' }}
      >
        Chatbot Script
      </Typography>
      <Typography sx={{ mb: 2, display: 'block' }}>
        Copy the script below, paste it into your website, and watch your
        chatbot go live in no time.
      </Typography>
      <div
        style={{
          marginBottom: '16px',
          padding: '8px 16px',
          borderRadius: '8px',
          border: '1px solid var(--rb-divider, #e0e0e0)'
        }}
      >
        <code style={{ display: 'block' }}>{script.trim()}</code>
      </div>
      <div style={{ marginTop: '16px' }}>
        <Button
          variant="contained"
          startIcon={<ContentCopyIcon />}
          onClick={handleCopy}
        >
          Copy Script
        </Button>
      </div>
    </div>
  );
};

export default ChatbotScript;
